export function errorMsg(error) {
  if (error.response) {
    return error.response.data.message;
  } else if (error.request) {
    return `Please Check Your Internet Connection`;
  } else {
    return error.message;
  }
}
